import { render, staticRenderFns } from "./Discarding.vue?vue&type=template&id=67a5b2b7"
import script from "./Discarding.vue?vue&type=script&lang=js"
export * from "./Discarding.vue?vue&type=script&lang=js"
import style0 from "./Discarding.vue?vue&type=style&index=0&id=67a5b2b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports